import React, { useEffect, useState } from 'react';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Modal, { BaseModalBackground } from 'styled-react-modal';
import { Route, NavLink as NavLinkRouter, withRouter } from 'react-router-dom';
import moment from 'moment';

import { GET_LABS_LIST, IS_DIAGNOSED } from '../../graphql';
import SpinLoader from '../../components/SpinLoader';
import EmptyState from '../labs/emptyState';
import { Query } from 'react-apollo';
import { LabStep1 } from './step1';
import { LabStep2 } from './step2';
import { LabStep3 } from './step3';
import { LabStep4 } from './step4';
import { LabStep5 } from './step5';
import LabDocumentViewer from './LabDocumentViewer';
import LabDocumentViewerReleased from './LabDocumentViewerReleased';
import styled from 'styled-components';
import LabResultsTrendPage from '../labs/labResultsTrendPage';
import LabsChart from '../landing/LabsChart';
import LabDetail from './LabDetail';
import LabDetailReleased from './LabDetailReleased';
import LabsChartMobile from '../landing/LabsChartMobile';
import { ItemCollection } from '../../components/icons';
import { AnalytesUtils } from '../../utils/analytes';
import UploadLabResultsPage from '../UploadLabResults';
import { withWizard } from 'react-albus';
import ConfirmModal from '../../components/ConfirmModal';
import IntakeOptionContinueNoLabModalContent from './IntakeOptionContinueNoLabModalContent';

const Inner = styled(Flex)`
  max-width: 750px;
  height: 100vh;
  background: rgb(253, 245, 242);
  overflow-y: auto;
  box-shadow: 5px 5px 30px 0px rgba(78, 101, 138, 0.35);
  @media screen and (min-width: 52em) {
    padding: 24px;
  }
`;

const BackButton = styled.div`
  background: rgba(180, 205, 244, 0.5);
  width: 100%;
  color: #333;
  padding: 6px 12px;
  @media screen and (min-width: 52em) {
    display: none;
  }
`;
const BackButtonDesktop = styled.div`
  @media screen and (max-width: 52em) {
    display: none;
  }
`;

const FlexDesktop = styled(Flex)`
  display: flex;
  @media screen and (max-width: 52em) {
    display: none;
  }
`;
const FlexMobile = styled(Flex)`
  display: flex;
  @media screen and (min-width: 52em) {
    display: none;
  }
`;
const DetailContainer = styled(Flex)`
  display: none;
  overflow-y: auto;
  &.selected {
    right: 0;
    top: 0;
    position: fixed;
    height: 100vh;
    z-index: 10;
    width: 100vw;
    max-width: 100vw;
    display: flex;
    justify-content: flex-end;
    background: transparent;
    backdrop-filter: blur(2px);
  }

  @media screen and (min-width: 52em) {
    display: none;
  }
`;

export const DateMobile = styled(Text)`
  display: none;

  @media screen and (max-width: 52em) {
    font-size: 18px;
    font-weight: 300;
    display: initial;
    margin-bottom: 12px;
  }
`;

const iconStyle = {
  width: '20px',
  height: '20px',
  background: '#FFFFFF',
  border: '3px solid #BCFFEB',
  margin: '10px',
  boxShadow: 'initial',
};
const SpecialModalBackground = styled(BaseModalBackground)`
  backdrop-filter: blur(5px);
`;

const NavLink = styled(NavLinkRouter)`
  text-decoration: none;
`;

const normalizeAnalyteName = (analyte) => {
  const anal = AnalytesUtils.getAnalyteStandardName(analyte);
  return anal;
};

const ContentResults = ({ lab, title }) => {
  const [isShowDoc, setIsShowDoc] = useState(false);
  const showDoc = () => {
    var byteCharacters = atob(lab.results.pdf);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  const handleClose = () => {
    setIsShowDoc(false);
  };

  return (
    <Flex flexDirection={'column'} style={{ textDecoration: 'none' }}>
      <Flex flexDirection={['column', 'row']}>
        <Text flex={1} className="vertical-timeline-element-title" fontWeight={600}>
          {title}
        </Text>
        {lab.results &&
          lab.results.pdf && (
            <Flex
              style={{ cursor: 'pointer' }}
              justifyContent={'center'}
              alignItems={'center'}
              onClick={
                () => showDoc()
                // setIsShowDoc(true)
              }
            >
              <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.2678 4.61557C14.391 4.73881 14.4609 4.90519 14.4609 5.07979V17.7474C14.4609 18.111 14.1671 18.4047 13.8036 18.4047H0.657312C0.293736 18.4047 0 18.111 0 17.7474V0.657312C0 0.293736 0.293736 0 0.657312 0H9.38108C9.55568 0 9.72411 0.0698395 9.84736 0.193086L14.2678 4.61557ZM12.9449 5.38174L9.07913 1.51593V5.38174H12.9449ZM9.72042 11.7753C9.4086 11.7651 9.07707 11.7891 8.70056 11.8361C8.20141 11.5282 7.86536 11.1053 7.62667 10.4839L7.64865 10.394L7.67412 10.2876C7.76245 9.91514 7.8099 9.64339 7.82407 9.36937C7.83475 9.16252 7.82325 8.9717 7.78648 8.79484C7.7187 8.41298 7.44858 8.1897 7.10822 8.17594C6.79086 8.163 6.49918 8.34027 6.42461 8.6149C6.30321 9.059 6.37429 9.64339 6.63166 10.64C6.30383 11.4216 5.87062 12.338 5.57997 12.849C5.19195 13.0491 4.88979 13.2311 4.6359 13.4328C4.30108 13.6992 4.09197 13.973 4.03446 14.2606C4.00652 14.3939 4.04863 14.5681 4.14456 14.7109C4.25343 14.8727 4.41734 14.9779 4.61392 14.9931C5.10999 15.0315 5.71964 14.52 6.39277 13.365C6.46035 13.3424 6.53184 13.3186 6.61913 13.289L6.86357 13.2064C7.01825 13.1543 7.1304 13.1169 7.24132 13.0809C7.72198 12.9244 8.08556 12.8256 8.41627 12.7693C8.991 13.077 9.6553 13.2787 10.1027 13.2787C10.472 13.2787 10.7216 13.0873 10.8118 12.786C10.8908 12.5214 10.8282 12.2145 10.6581 12.0448C10.4823 11.8721 10.159 11.7895 9.72042 11.7753ZM4.62645 14.4132V14.4058L4.62912 14.3988C4.65918 14.3211 4.69776 14.247 4.74415 14.1778C4.83207 14.0427 4.95305 13.9005 5.103 13.7491C5.18352 13.668 5.26733 13.5889 5.36572 13.5002C5.3877 13.4804 5.5282 13.3554 5.55449 13.3307L5.78394 13.1171L5.61714 13.3827C5.36408 13.7861 5.13525 14.0765 4.93929 14.2659C4.86719 14.3358 4.80372 14.3871 4.75237 14.4202C4.73541 14.4315 4.71747 14.4413 4.69876 14.4494C4.69033 14.4529 4.68294 14.4549 4.67554 14.4555C4.66774 14.4565 4.65981 14.4555 4.65254 14.4524C4.64481 14.4492 4.63821 14.4438 4.63356 14.4368C4.62892 14.4298 4.62645 14.4216 4.62645 14.4132ZM7.21339 9.92952L7.16696 10.0117L7.13821 9.92172C7.07453 9.7198 7.0277 9.41559 7.01475 9.14116C6.99997 8.82894 7.02482 8.6416 7.12342 8.6416C7.26186 8.6416 7.32533 8.86345 7.33026 9.19724C7.33478 9.49056 7.28877 9.7958 7.21339 9.92952ZM7.09404 11.1304L7.12547 11.0472L7.1684 11.1252C7.40853 11.5615 7.72013 11.9255 8.06276 12.1792L8.1367 12.2338L8.04653 12.2523C7.71109 12.3217 7.39867 12.4261 6.97141 12.5984C7.01599 12.5803 6.52732 12.7804 6.40366 12.8279L6.29582 12.8691L6.35333 12.7689C6.60702 12.3273 6.84159 11.7969 7.09404 11.1304ZM10.3317 12.6968C10.1703 12.7605 9.82271 12.7036 9.21079 12.4423L9.0555 12.3762L9.22394 12.3638C9.70255 12.3283 10.0415 12.3546 10.2391 12.4269C10.3233 12.4577 10.3794 12.4965 10.4042 12.5409C10.4173 12.5619 10.4217 12.5872 10.4165 12.6114C10.4113 12.6356 10.3969 12.6568 10.3763 12.6705C10.3632 12.682 10.3481 12.6909 10.3317 12.6968Z"
                  fill="#344F7A"
                />
              </svg>

              <Text ml={3} fontSize={'14px'} style={{ textDecoration: 'underline' }} fontWeight={300}>
                View Document
              </Text>
            </Flex>
          )}
      </Flex>
      {lab.results &&
        lab.results.outcome && (
          <>
            <FlexDesktop mb={'8px'} flex={1} mt={3}>
              <Flex flex={1} style={{ paddingRight: '20px' }} paddingRight={'20px'}>
                <Text fontSize={'12px'} style={{ opacity: 0.6 }} opacity={0.6} color={'#344F7A'}>
                  Analyte
                </Text>
              </Flex>
              <Text fontSize={'12px'} style={{ opacity: 0.6, paddingLeft: '20px', paddingRight: '20px' }} width="33%" opacity={0.6} color={'#344F7A'}>
                Value
              </Text>

              <Flex justifyContent={'center'} alignItems={'center'} style={{ paddingLeft: '20px' }} paddingLeft={'20px'}>
                <Flex justifyContent={'center'} alignItems={'center'} width={'80px'}>
                  <Text fontSize={'12px'} style={{ opacity: 0.6 }} color={'#344F7A'} textAlign={'center'}>
                    Interpretation
                  </Text>
                </Flex>
              </Flex>
            </FlexDesktop>
            {lab.results.outcome.map((x) => {
              return (
                <>
                  <FlexDesktop mb={'8px'} flex={1}>
                    <Flex flex={1} style={{ borderRight: '1px solid #E2E2E2', paddingRight: '20px' }} paddingRight={'20px'}>
                      <Text fontSize={'14px'}>{x.hormone}</Text>
                    </Flex>
                    <Text fontSize={'14px'} width="33%" style={{ paddingLeft: '20px', paddingRight: '20px' }}>{`${x.value} ${x.unit}`}</Text>

                    <Flex justifyContent={'center'} alignItems={'center'} style={{ borderLeft: '1px solid #E2E2E2', paddingLeft: '20px' }} paddingLeft={'20px'}>
                      <Flex justifyContent={'center'} alignItems={'center'} style={{ backgroundColor: !x.abnormal ? '#BCFFEB' : '#FFBCBC', borderRadius: '8px' }} width={'80px'}>
                        <Text fontSize={'14px'} textAlign={'center'}>{`${x.abnormal ? 'Abnormal' : 'Normal'}`}</Text>
                      </Flex>
                    </Flex>
                  </FlexDesktop>
                  <FlexMobile mb={'8px'} flex={1}>
                    <Flex flexDirection={'column'} flex={1}>
                      <Flex style={{ paddingRight: '20px' }} paddingRight={'20px'}>
                        <Text fontSize={'14px'}>{x.hormone}</Text>
                      </Flex>
                      <Text fontSize={'14px'} width="33%" style={{ paddingRight: '20px' }}>{`${x.value} ${x.unit}`}</Text>
                    </Flex>
                    <Flex justifyContent={'center'} alignItems={'center'} style={{ paddingLeft: '20px' }} paddingLeft={'20px'}>
                      <Flex justifyContent={'center'} alignItems={'center'} style={{ backgroundColor: !x.abnormal ? '#BCFFEB' : '#FFBCBC', borderRadius: '8px' }} width={'80px'}>
                        <Text fontSize={'14px'} textAlign={'center'}>{`${x.abnormal ? 'Abnormal' : 'Normal'}`}</Text>
                      </Flex>
                    </Flex>
                  </FlexMobile>
                </>
              );
            })}
          </>
        )}
      {!!isShowDoc && (
        <Modal isOpen={isShowDoc} onBackgroundClick={handleClose} onEscapeKeydown={handleClose}>
          {/* <SpecialModalBackground> */}
          <Box
            style={{
              margin: '0 auto',
              alignSelf: 'center',
              borderRadius: '20px',
              position: 'relative',
              backgroundColor: 'white',
              padding: '24px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              height: '96%',
              maxHeight: '96%',
              width: '100%',
              maxWidth: '100%',
            }}
          >
            <LabDocumentViewer doc={lab.results.pdf} />
            <Flex flexDirection={'row'} justifyContent="space-between" width={'100%'}>
              <Button variant={'primary'} onClick={handleClose} mt={4}>
                Close
              </Button>
            </Flex>
          </Box>
          {/* </SpecialModalBackground> */}
        </Modal>
      )}
    </Flex>
  );
};

const LabDisplay = ({ item, onClick, isMinimized }) => {
  const [isShowDoc, setIsShowDoc] = useState(false);
  // console.log({ item });
  const handleClose = () => {
    setIsShowDoc(false);
  };
  const calcValue = (value) => {
    if (!value || value === '-') {
      return '-';
    }
    try {
      let v = parseFloat(value);
      if (isNaN(v)) return value;
      return parseFloat(v.toFixed(2)).toString();
    } catch (error) {
      return value;
    }
  };
  return (
    <Flex
      flexDirection={'column'}
      width="100%"
      paddingX={2}
      style={{ cursor: !!item.pwnId && !item.attachmentExists && item.analytes && item.analytes.length > 0 ? 'pointer' : '' }}
      onClick={() => {
        if (!!item.pwnId && !item.attachmentExists && item.analytes && item.analytes.length > 0) {
          onClick();
        }
      }}
    >
      <DateMobile>{item.status === 'pending' ? 'Pending' : !item.date ? 'N/A' : moment.utc(item.date, 'x').format('MM/DD/YYYY')}</DateMobile>
      <Flex flexDirection={['column', 'row']} mb={[item.analytes.length > 0 ? 3 : 0, 0]}>
        <Text
          flex={1}
          style={{ cursor: !!item.pwnId && item.analytes && item.analytes.length > 0 ? 'pointer' : '' }}
          className="vertical-timeline-element-title"
          fontWeight={600}
          onClick={() => {
            if (!!item.pwnId && !!item.attachmentExists && item.analytes && item.analytes.length > 0) {
              onClick();
            }
          }}
        >
          {!!item.pwnId
            ? 'Paloma Thyroid Test Kit'
            : item.analytes.length > 0
              ? `${
                  !item.lab && item.description
                    ? item.description.toLowerCase() === 'lab*'
                      ? 'Lab Results'
                      : item.description
                    : item.lab.toLowerCase().indexOf('paloma') > -1
                      ? 'Paloma Thyroid Test Kit'
                      : `Lab results from ${item.lab}`
                }`
              : 'Lab document uploaded manually'}
        </Text>
        {!!item.attachmentExists && (
          <Flex
            style={{ cursor: 'pointer' }}
            justifyContent={['flex-start', 'center']}
            alignItems={'center'}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsShowDoc(true);
            }}
            mt={[3, 0]}
          >
            <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.2678 4.61557C14.391 4.73881 14.4609 4.90519 14.4609 5.07979V17.7474C14.4609 18.111 14.1671 18.4047 13.8036 18.4047H0.657312C0.293736 18.4047 0 18.111 0 17.7474V0.657312C0 0.293736 0.293736 0 0.657312 0H9.38108C9.55568 0 9.72411 0.0698395 9.84736 0.193086L14.2678 4.61557ZM12.9449 5.38174L9.07913 1.51593V5.38174H12.9449ZM9.72042 11.7753C9.4086 11.7651 9.07707 11.7891 8.70056 11.8361C8.20141 11.5282 7.86536 11.1053 7.62667 10.4839L7.64865 10.394L7.67412 10.2876C7.76245 9.91514 7.8099 9.64339 7.82407 9.36937C7.83475 9.16252 7.82325 8.9717 7.78648 8.79484C7.7187 8.41298 7.44858 8.1897 7.10822 8.17594C6.79086 8.163 6.49918 8.34027 6.42461 8.6149C6.30321 9.059 6.37429 9.64339 6.63166 10.64C6.30383 11.4216 5.87062 12.338 5.57997 12.849C5.19195 13.0491 4.88979 13.2311 4.6359 13.4328C4.30108 13.6992 4.09197 13.973 4.03446 14.2606C4.00652 14.3939 4.04863 14.5681 4.14456 14.7109C4.25343 14.8727 4.41734 14.9779 4.61392 14.9931C5.10999 15.0315 5.71964 14.52 6.39277 13.365C6.46035 13.3424 6.53184 13.3186 6.61913 13.289L6.86357 13.2064C7.01825 13.1543 7.1304 13.1169 7.24132 13.0809C7.72198 12.9244 8.08556 12.8256 8.41627 12.7693C8.991 13.077 9.6553 13.2787 10.1027 13.2787C10.472 13.2787 10.7216 13.0873 10.8118 12.786C10.8908 12.5214 10.8282 12.2145 10.6581 12.0448C10.4823 11.8721 10.159 11.7895 9.72042 11.7753ZM4.62645 14.4132V14.4058L4.62912 14.3988C4.65918 14.3211 4.69776 14.247 4.74415 14.1778C4.83207 14.0427 4.95305 13.9005 5.103 13.7491C5.18352 13.668 5.26733 13.5889 5.36572 13.5002C5.3877 13.4804 5.5282 13.3554 5.55449 13.3307L5.78394 13.1171L5.61714 13.3827C5.36408 13.7861 5.13525 14.0765 4.93929 14.2659C4.86719 14.3358 4.80372 14.3871 4.75237 14.4202C4.73541 14.4315 4.71747 14.4413 4.69876 14.4494C4.69033 14.4529 4.68294 14.4549 4.67554 14.4555C4.66774 14.4565 4.65981 14.4555 4.65254 14.4524C4.64481 14.4492 4.63821 14.4438 4.63356 14.4368C4.62892 14.4298 4.62645 14.4216 4.62645 14.4132ZM7.21339 9.92952L7.16696 10.0117L7.13821 9.92172C7.07453 9.7198 7.0277 9.41559 7.01475 9.14116C6.99997 8.82894 7.02482 8.6416 7.12342 8.6416C7.26186 8.6416 7.32533 8.86345 7.33026 9.19724C7.33478 9.49056 7.28877 9.7958 7.21339 9.92952ZM7.09404 11.1304L7.12547 11.0472L7.1684 11.1252C7.40853 11.5615 7.72013 11.9255 8.06276 12.1792L8.1367 12.2338L8.04653 12.2523C7.71109 12.3217 7.39867 12.4261 6.97141 12.5984C7.01599 12.5803 6.52732 12.7804 6.40366 12.8279L6.29582 12.8691L6.35333 12.7689C6.60702 12.3273 6.84159 11.7969 7.09404 11.1304ZM10.3317 12.6968C10.1703 12.7605 9.82271 12.7036 9.21079 12.4423L9.0555 12.3762L9.22394 12.3638C9.70255 12.3283 10.0415 12.3546 10.2391 12.4269C10.3233 12.4577 10.3794 12.4965 10.4042 12.5409C10.4173 12.5619 10.4217 12.5872 10.4165 12.6114C10.4113 12.6356 10.3969 12.6568 10.3763 12.6705C10.3632 12.682 10.3481 12.6909 10.3317 12.6968Z"
                fill="#344F7A"
              />
            </svg>

            <Text ml={3} fontSize={'14px'} style={{ textDecoration: 'underline' }} fontWeight={300}>
              View Document
            </Text>
          </Flex>
        )}
      </Flex>
      {item.analytes.length > 0 ? (
        <>
          <FlexDesktop
            mb={'8px'}
            flex={1}
            mt={3}
            onClick={() => {
              if (!!item.pwnId) {
                onClick();
              }
            }}
            style={{ cursor: !!item.pwnId ? 'pointer' : '' }}
          >
            <Flex flex={1} style={{ paddingRight: '20px' }} paddingRight={'20px'}>
              <Text fontSize={'12px'} style={{ opacity: 0.6 }} opacity={0.6} color={'#344F7A'}>
                Analyte
              </Text>
            </Flex>
            <Text fontSize={'12px'} style={{ opacity: 0.6, paddingLeft: '20px', paddingRight: '20px' }} width="33%" opacity={0.6} color={'#344F7A'}>
              Value
            </Text>

            <Flex justifyContent={'center'} alignItems={'center'} style={{ paddingLeft: '20px' }} paddingLeft={'20px'}>
              <Flex justifyContent={'center'} alignItems={'center'} width={'80px'}>
                <Text fontSize={'12px'} style={{ opacity: 0.6 }} color={'#344F7A'} textAlign={'center'}>
                  Interpretation
                </Text>
              </Flex>
            </Flex>
          </FlexDesktop>
          {item.analytes.map((x) => {
            return (
              <>
                <FlexDesktop
                  mb={'8px'}
                  flex={1}
                  onClick={() => {
                    if (!!item.pwnId) {
                      onClick();
                    }
                  }}
                  style={{ cursor: !!item.pwnId ? 'pointer' : '' }}
                >
                  <Flex flex={1} style={{ borderRight: '1px solid #E2E2E2', paddingRight: '20px' }} paddingRight={'20px'}>
                    <Text fontSize={'14px'}>{normalizeAnalyteName(x.analyte)}</Text>
                  </Flex>
                  <Text fontSize={'14px'} width="33%" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                    {calcValue(x.value)} {x.unit}
                  </Text>

                  <Flex justifyContent={'center'} alignItems={'center'} style={{ borderLeft: '1px solid #E2E2E2', paddingLeft: '20px' }} paddingLeft={'20px'}>
                    <Flex justifyContent={'center'} alignItems={'center'} style={{ backgroundColor: x.status === 'normal' ? '#BCFFEB' : '#FFBCBC', borderRadius: '8px' }} width={'80px'}>
                      <Text fontSize={'14px'} textAlign={'center'}>
                        {x.status}
                        {/* {`${x.abnormal ? 'Abnormal' : 'Normal'}`} */}
                      </Text>
                    </Flex>
                  </Flex>
                </FlexDesktop>

                <FlexMobile
                  mb={'8px'}
                  flex={1}
                  display={['flex', 'none']}
                  onClick={() => {
                    if (!!item.pwnId) {
                      onClick();
                    }
                  }}
                  style={{ cursor: !!item.pwnId ? 'pointer' : '' }}
                >
                  <Flex flex={1} flexDirection={'column'}>
                    <Flex flex={1} style={{ paddingRight: '20px' }} paddingRight={'20px'}>
                      <Text fontSize={'14px'}>{normalizeAnalyteName(x.analyte)}</Text>
                    </Flex>
                    <Text fontSize={'12px'} style={{ paddingRight: '20px', fontWeight: 300 }}>
                      {calcValue(x.value)} {x.unit}
                    </Text>
                  </Flex>

                  <Flex justifyContent={'center'} alignItems={'center'} style={{ paddingLeft: '20px' }} paddingLeft={'20px'}>
                    <Flex justifyContent={'center'} alignItems={'center'} style={{ backgroundColor: x.status === 'normal' ? '#BCFFEB' : '#FFBCBC', borderRadius: '8px' }} width={'80px'}>
                      <Text fontSize={'14px'} textAlign={'center'}>
                        {x.status}
                      </Text>
                    </Flex>
                  </Flex>
                </FlexMobile>
              </>
            );
          })}
        </>
      ) : null}
      {!!isShowDoc && (
        <Modal isOpen={isShowDoc} onBackgroundClick={handleClose} onEscapeKeydown={handleClose}>
          {/* <SpecialModalBackground> */}
          <Flex
            flexDirection={'column'}
            style={{
              margin: '0 auto',
              alignSelf: 'center',
              borderRadius: '20px',
              position: 'relative',
              backgroundColor: 'white',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '96',
              height: '96%',
              width: '700px',
              maxWidth: '96%',
              overflow: 'hidden',
              paddingTop: '4px',
              paddingRight: 0,
            }}
          >
            <Flex justifyContent="flex-end" style={{ borderBottom: '1px solid rgb(229, 233, 236)' }}>
              <Text mb={1} mt={1} mr={2} style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={handleClose}>
                Close
              </Text>
            </Flex>
            <Flex flex={1} style={{ overflow: 'hidden', width: '100%' }}>
              <LabDocumentViewerReleased labResultId={item.labResultId} />
            </Flex>
            {/* <Flex flexDirection={'row'} justifyContent="space-between" width={'100%'}>
                <Button variant={'primary'} onClick={handleClose} mt={4}>
                  Close
                </Button>
              </Flex> */}
          </Flex>
          {/* </SpecialModalBackground> */}
        </Modal>
      )}
    </Flex>
  );
};
const Content = ({ lab, title, date }) => {
  if (lab.currentStep && lab.currentStep.step) {
    // console.log('current.step', current.step)
    if (lab.currentStep.step === 1) {
      return <LabStep1 date={date} />;
    } else if (lab.currentStep.step === 2) {
      return <LabStep2 date={date} currentStep={lab.currentStep} />;
    } else if (lab.currentStep.step === 3) {
      return <LabStep3 date={date} currentStep={lab.currentStep} />;
    } else if (lab.currentStep.step === 4) {
      return <LabStep4 date={date} currentStep={lab.currentStep} />;
    } else if (lab.currentStep.step === 5) {
      return <LabStep5 date={date} currentStep={lab.currentStep} />;
    }
  } else {
    if (lab.status === 'registered') {
      return <LabStep1 date={date} />;
    }
  }

  return <ContentResults title={title} lab={lab} />;
};
const Wrap = styled(Flex)`
  max-height: '';
  @media screen and (min-width: 52em) {
    max-height: ${(props) => (!props.showTrend ? `calc(100vh - 90px)` : '')};
  }
`;
const LabResults2 = ({ isDiagnosed, ...props }) => {
  const [continueNoLabsModal, setContinueNoLabsModal] = useState(false);
  const [showTrend, setShowTrend] = useState(false);
  const [isMobileSize, setIsMobileSize] = useState(null);
  useEffect(() => {
    if (window.innerWidth > 425) {
      setIsMobileSize(false);
    } else {
      setIsMobileSize(true);
    }

    const updateMedia = () => {
      if (window.innerWidth > 425) {
        setIsMobileSize(false);
      } else {
        setIsMobileSize(true);
      }
    };
    window.addEventListener('resize', updateMedia);
    return () => window.removeEventListener('resize', updateMedia);
  }, []);
  return (
    <Flex flexDirection={'column'} width={'100%'} height="100%" maxHeight={'100%'} style={{ overflow: 'hidden' }}>
      {props.history && props.history.location && props.history.location.pathname && props.history.location.pathname.indexOf('/u/upload') > -1 ? (
        <Route
          path={`/${props.intakeRoute}/u/upload`}
          component={(props) => (
            <UploadLabResultsPage
              isNewIntakeIntegration
              onSkip={() => {
                props.history.goBack();
              }}
            />
          )}
        />
      ) : (
        <Query query={GET_LABS_LIST} notifyOnNetworkStatusChange={true}>
          {({ loading, error, data, refetch, networkStatus }) => {
            if (loading || networkStatus === 4) {
              return (
                <Flex flex={1} justifyContent="center" alignItems="center">
                  <SpinLoader />
                </Flex>
              );
            }

            if (error) {
              return (
                <Flex flex={1} justifyContent="center" alignItems="center" flexDirection={'column'}>
                  <Text fontSize={5} fontWeight={600} textAlign="center">
                    Unable to retrieve lab tests. Please try again.
                  </Text>
                  <Button variant={'primary'} mt={4} onClick={() => refetch()}>
                    Retry
                  </Button>
                </Flex>
              );
            }

            const { patientGetLabLists } = data;

            const selected =
              props.history && props.history.location && props.history.location.pathname && (props.history.location.pathname.indexOf('/p/') > -1 || props.history.location.pathname.indexOf('/r/') > -1)
                ? 'selected'
                : null;
            const labs = patientGetLabLists;
            if (!labs || labs.length === 0 || ((!labs.pendings || labs.pendings.length < 1) && (!labs.released || labs.released.length < 1))) {
              return (
                <Wrap flex={1} flexDirection={'column'} overflowY={['auto', !showTrend ? 'hidden' : 'auto']} showTrend={showTrend}>
                  <Flex flexDirection={['column']} p={['16px', 4]} style={{ borderBottom: '1px solid rgba(52, 79, 122, 0.19)' }}>
                    <Text style={{ fontWeight: 600 }} mb={3}>
                      Need to Upload Lab Results?
                    </Text>
                    <Text>Here are the lab results we currently have on file. If anything is missing, please upload your latest labs.</Text>
                    <Flex flexDirection={['column', 'row']} style={{ gap: '16px' }} mt={3}>
                      <Button
                        variant={'white'}
                        style={{ border: '1px solid #4E658A', paddingTop: '8px', paddingBottom: '8px' }}
                        onClick={() => {
                          props.history.push(`/${props.intakeRoute}/u/upload`);
                        }}
                      >
                        Upload lab results
                      </Button>
                    </Flex>
                  </Flex>
                  <Flex flexDirection={['column']} p={['16px', 4]} mt={4}>
                    <Text>Without updated labs, medications may not be provided.</Text>

                    <Text mb={4} mt={3}>
                      {data && data.disclaimer ? data.disclaimer : 'For new patients, labs within four months are required in order to prescribe medication or discuss potential treatment plans.'}
                    </Text>
                    <Flex justifyContent={'center'}>
                      <Button
                        variant={'primary'}
                        style={{ paddingTop: '8px', paddingBottom: '8px' }}
                        onClick={() => {
                          setContinueNoLabsModal(true);
                          // props.wizard.next();
                        }}
                      >
                        Continue
                      </Button>
                    </Flex>
                  </Flex>
                </Wrap>
              );
            }
            return (
              <Wrap flex={1} flexDirection={'column'} overflowY={['auto', !showTrend ? 'hidden' : 'auto']} showTrend={showTrend}>
                <Flex flexDirection={['column']} p={['16px', 4]} style={{ borderBottom: '1px solid rgba(52, 79, 122, 0.19)' }}>
                  <Text style={{ fontWeight: 600 }} mb={3}>
                    Need to Upload Lab Results?
                  </Text>
                  <Text>Here are the lab results we currently have on file. If anything is missing, please upload your latest labs.</Text>
                  <Flex flexDirection={['column', 'row']} style={{ gap: '16px' }} mt={3}>
                    <Button
                      variant={'white'}
                      style={{ border: '1px solid #4E658A', paddingTop: '8px', paddingBottom: '8px' }}
                      onClick={() => {
                        props.history.push(`/${props.intakeRoute}/u/upload`);
                      }}
                    >
                      Upload lab results
                    </Button>
                    <Button
                      variant={'primary'}
                      style={{ paddingTop: '8px', paddingBottom: '8px' }}
                      onClick={() => {
                        props.wizard.next();
                      }}
                    >
                      Continue
                    </Button>
                  </Flex>
                </Flex>
                <Flex flex={1} style={{ overflowY: 'auto' }} flexDirection={'column'}>
                  <Flex justifyContent={'center'} alignItems={'center'} mt={2} mb={2}>
                    <Flex
                      style={{
                        opacity: 0.75,
                        border: '1px solid rgb(53, 78, 121)',
                        padding: '4px 12px',
                        borderRadius: '8px',
                        background: '#e1ebfa',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      flexDirection={'row'}
                    >
                      <svg width="14" height="14" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M60 10C87.615 10 110 32.385 110 60C110 87.615 87.615 110 60 110C32.385 110 10 87.615 10 60C10 32.385 32.385 10 60 10ZM60 20C49.3913 20 39.2172 24.2143 31.7157 31.7157C24.2143 39.2172 20 49.3913 20 60C20 70.6087 24.2143 80.7828 31.7157 88.2843C39.2172 95.7857 49.3913 100 60 100C70.6087 100 80.7828 95.7857 88.2843 88.2843C95.7857 80.7828 100 70.6087 100 60C100 49.3913 95.7857 39.2172 88.2843 31.7157C80.7828 24.2143 70.6087 20 60 20ZM60 75C61.3261 75 62.5979 75.5268 63.5355 76.4645C64.4732 77.4021 65 78.6739 65 80C65 81.3261 64.4732 82.5979 63.5355 83.5355C62.5979 84.4732 61.3261 85 60 85C58.6739 85 57.4021 84.4732 56.4645 83.5355C55.5268 82.5979 55 81.3261 55 80C55 78.6739 55.5268 77.4021 56.4645 76.4645C57.4021 75.5268 58.6739 75 60 75ZM60 30C61.3261 30 62.5979 30.5268 63.5355 31.4645C64.4732 32.4021 65 33.6739 65 35V65C65 66.3261 64.4732 67.5979 63.5355 68.5355C62.5979 69.4732 61.3261 70 60 70C58.6739 70 57.4021 69.4732 56.4645 68.5355C55.5268 67.5979 55 66.3261 55 65V35C55 33.6739 55.5268 32.4021 56.4645 31.4645C57.4021 30.5268 58.6739 30 60 30Z"
                          fill="rgb(53, 78, 121)"
                        />
                      </svg>

                      <Text ml={2}>Uploaded labs might take a few minutes to appear.</Text>
                    </Flex>
                  </Flex>

                  {/* <Button
                      variant={'white'}
                      style={{ border: '1px solid #4E658A', paddingTop: '8px', paddingBottom: '8px', alignSelf:'center' }}
                      mt={2}
                      onClick={() => {
                        refetch();
                      }}
                    >
                      Refresh List
                    </Button> */}
                  <VerticalTimeline layout="1-column" lineColor="#344F7A">
                    {labs.pendings
                      .sort((a, b) => {
                        const dateA = a.resultedAt || a.created;
                        const dateB = b.resultedAt || b.created;

                        if (dateA < dateB) return 1;
                        if (dateA > dateB) return -1;

                        return 0;
                      })
                      .map((x) => {
                        let title = `Thyroid Test`;
                        if (x && x.biomarkers && x.biomarkers.length > 0) {
                          if (x.biomarkers.indexOf('rT3') > -1) {
                            title += ` + rT3`;
                          }
                          if (x.biomarkers.indexOf('Vit. D') > -1) {
                            title += ` + Vit. D`;
                          }
                        }
                        return (
                          // {timelineElements}
                          <VerticalTimelineElement
                            className="vertical-timeline-element--work"
                            contentStyle={{ background: 'white' }}
                            date={!!x.resultedAt ? `${moment(x.resultedAt).format('MM/DD/YYYY')}` : 'Pending'}
                            iconStyle={iconStyle}
                            icon={<div />}
                          >
                            <NavLink to={`/${props.intakeRoute}/p/${x.id}`}>
                              <>
                                <Content lab={x} title={title} date={!!x.resultedAt ? `${moment(x.resultedAt).format('DD MMM YYYY')}` : 'Pending'} />

                                <svg
                                  style={{ position: 'absolute', right: '-20px', top: '40%', cursor: 'pointer' }}
                                  className="RArr"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="24"
                                  viewBox="0 0 11 24"
                                  fill="none"
                                >
                                  <path
                                    d="M0.295606 2.02351C0.20118 1.90901 0.12736 1.77433 0.078361 1.62714C0.0293618 1.47995 0.0061425 1.32314 0.0100301 1.16567C0.0139177 1.0082 0.0448356 0.853153 0.101018 0.709374C0.157201 0.565596 0.237548 0.435905 0.337472 0.327707C0.437396 0.219508 0.554941 0.134922 0.683394 0.078776C0.811848 0.0226304 0.948694 -0.00397488 1.08612 0.000479721C1.22355 0.00493432 1.35886 0.0403613 1.48434 0.104738C1.60982 0.169115 1.723 0.26118 1.81743 0.375678L10.7139 11.1693C10.8976 11.392 11 11.6868 11 11.9933C11 12.2997 10.8976 12.5945 10.7139 12.8172L1.81743 23.612C1.72362 23.729 1.61047 23.8235 1.48453 23.89C1.35859 23.9565 1.22238 23.9936 1.08381 23.9992C0.945238 24.0049 0.80707 23.9789 0.677332 23.9229C0.547593 23.8668 0.428869 23.7818 0.328055 23.6727C0.227242 23.5636 0.146348 23.4326 0.0900744 23.2874C0.0338003 23.1422 0.00326716 22.9857 0.000248143 22.8268C-0.00277087 22.668 0.0217842 22.51 0.0724878 22.3622C0.123192 22.2143 0.199033 22.0794 0.295606 21.9654L8.51386 11.9933L0.295606 2.02351Z"
                                    fill="#4E658A"
                                  />
                                </svg>
                              </>
                            </NavLink>
                          </VerticalTimelineElement>
                        );
                      })}
                    {JSON.parse(JSON.stringify(labs.released))
                      .sort((a, b) => {
                        if (a.status === 'pending') return -1;
                        if (b.status === 'pending') return 1;
                        if (!a.date) return 1;
                        if (!b.date) return -1;

                        const ma = moment(a.date, 'x');
                        const mb = moment(b.date, 'x');
                        if (ma.isBefore(mb)) return 1;
                        return -1;
                      })
                      .map((x) => {
                        let title = `Thyroid Test`;
                        if (x && x.biomarkers && x.biomarkers.length > 0) {
                          if (x.biomarkers.indexOf('rT3') > -1) {
                            title += ` + rT3`;
                          }
                          if (x.biomarkers.indexOf('Vit. D') > -1) {
                            title += ` + Vit. D`;
                          }
                        }
                        return (
                          <>
                            <VerticalTimelineElement
                              className="vertical-timeline-element--work"
                              contentStyle={{ background: 'white' }}
                              date={x.status === 'pending' ? 'Pending' : !x.date ? 'N/A' : moment.utc(x.date, 'x').format('MM/DD/YYYY')}
                              iconStyle={iconStyle}
                              icon={<div />}
                            >
                              <LabDisplay
                                item={x}
                                onClick={() => {
                                  if (!x.pwnId) return;
                                  props.history.push(`/${props.intakeRoute}/r/${x.labResultId}`);
                                }}
                                date={x.status === 'pending' ? 'Pending' : !x.date ? 'N/A' : moment.utc(x.date, 'x').format('DD MMM YYYY')}
                              />
                              {!!x.pwnId &&
                                x.analytes &&
                                x.analytes.length > 0 && (
                                  <svg
                                    style={{ position: 'absolute', right: '-20px', top: '40%', cursor: 'pointer' }}
                                    className="RArr"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="11"
                                    height="24"
                                    viewBox="0 0 11 24"
                                    fill="none"
                                    onClick={() => {
                                      props.history.push(`/${props.intakeRoute}/r/${x.labResultId}`);
                                    }}
                                  >
                                    <path
                                      d="M0.295606 2.02351C0.20118 1.90901 0.12736 1.77433 0.078361 1.62714C0.0293618 1.47995 0.0061425 1.32314 0.0100301 1.16567C0.0139177 1.0082 0.0448356 0.853153 0.101018 0.709374C0.157201 0.565596 0.237548 0.435905 0.337472 0.327707C0.437396 0.219508 0.554941 0.134922 0.683394 0.078776C0.811848 0.0226304 0.948694 -0.00397488 1.08612 0.000479721C1.22355 0.00493432 1.35886 0.0403613 1.48434 0.104738C1.60982 0.169115 1.723 0.26118 1.81743 0.375678L10.7139 11.1693C10.8976 11.392 11 11.6868 11 11.9933C11 12.2997 10.8976 12.5945 10.7139 12.8172L1.81743 23.612C1.72362 23.729 1.61047 23.8235 1.48453 23.89C1.35859 23.9565 1.22238 23.9936 1.08381 23.9992C0.945238 24.0049 0.80707 23.9789 0.677332 23.9229C0.547593 23.8668 0.428869 23.7818 0.328055 23.6727C0.227242 23.5636 0.146348 23.4326 0.0900744 23.2874C0.0338003 23.1422 0.00326716 22.9857 0.000248143 22.8268C-0.00277087 22.668 0.0217842 22.51 0.0724878 22.3622C0.123192 22.2143 0.199033 22.0794 0.295606 21.9654L8.51386 11.9933L0.295606 2.02351Z"
                                      fill="#4E658A"
                                    />
                                  </svg>
                                )}
                            </VerticalTimelineElement>
                          </>
                        );
                      })}
                  </VerticalTimeline>
                </Flex>
                <DetailContainer
                  flex={1}
                  justifyContent="center"
                  className={selected}
                  onClick={() => {
                    props.history.goBack();
                  }}
                >
                  <Inner
                    flex={1}
                    flexDirection="column"
                    pt={[0, 0, 3]}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <div>
                      <BackButtonDesktop>
                        <svg
                          onClick={() => props.history.goBack()}
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ transform: 'rotate(180deg)', cursor: 'pointer' }}
                        >
                          <path d="M21.3337 8.33335L31.3337 20L21.3337 31.6667" stroke="#4E658A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M11.6667 8.33335L21.6667 20L11.6667 31.6667" stroke="#4E658A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </BackButtonDesktop>
                      <BackButton onClick={() => props.history.goBack()}>{'<  Your Lab Results'}</BackButton>
                    </div>

                    <Route
                      path={`/${props.intakeRoute}/p/:id`}
                      component={(props) => (
                        <LabDetail
                          forceId={
                            props.history && props.history.location && props.history.location.pathname && props.history.location.pathname.indexOf('/p/') > -1
                              ? props.history.location.pathname.split('/p/')[1]
                              : props.history && props.history.location && props.history.location.pathname && props.history.location.pathname.indexOf('/r/') > -1
                                ? props.history.location.pathname.split('/r/')[1]
                                : -1
                          }
                          labs={labs}
                          {...props}
                          isDiagnosed={isDiagnosed}
                        />
                      )}
                    />
                    <Route
                      path={`/${props.intakeRoute}/r/:id`}
                      component={(props) => (
                        <LabDetailReleased
                          forceId={
                            props.history && props.history.location && props.history.location.pathname && props.history.location.pathname.indexOf('/p/') > -1
                              ? props.history.location.pathname.split('/p/')[1]
                              : props.history && props.history.location && props.history.location.pathname && props.history.location.pathname.indexOf('/r/') > -1
                                ? props.history.location.pathname.split('/r/')[1]
                                : -1
                          }
                          labs={labs}
                          {...props}
                          isDiagnosed={isDiagnosed}
                        />
                      )}
                    />
                  </Inner>
                </DetailContainer>
              </Wrap>
            );
          }}
        </Query>
      )}
      {!!continueNoLabsModal && (
        <Modal isOpen={continueNoLabsModal}>
          <IntakeOptionContinueNoLabModalContent
            onCancel={() => setContinueNoLabsModal(false)}
            onContinue={() => {
              props.wizard.next();
            }}
          />
        </Modal>
      )}
      <Flex id={'testRightPane'} style={{}} />
    </Flex>
  );
};

const LabResults2Wrapper = (props) => (
  <Query query={IS_DIAGNOSED} fetchPolicy="network-only">
    {({ loading, error, data }) => {
      if (loading) {
        return (
          <Flex flex={1} justifyContent="center" alignItems="center">
            <SpinLoader />
          </Flex>
        );
      }
      return <LabResults2 {...props} isDiagnosed={data.isDiagnosed} isNewIntakeIntegration onSkip={props.closeUpload} />;
    }}
  </Query>
);

export default withRouter(withWizard(LabResults2Wrapper));
